import { createSelector } from "reselect";

import Store, { RootState } from "../../../redux/store";

import {
  CampaignBriefState,
  IBriefOwner,
  ICampaignBriefData,
} from "../types/campaign-brief-state/campaign-brief-state.interface";
import { CampaignBriefForm } from "../types/campaign-brief-form/campaign-brief-form.interface";
import { CreateCampaignBriefForm } from "../types/create-campaign-brief-form.interface";
import { DuplicateCampaignBriefForm } from "../types/duplicate-campaign-brief-form.interface";

import * as actions from "./campaign-brief.actions";

export function getCampaignBriefState(state: RootState): CampaignBriefState {
  return state.campaignBrief;
}

export const getBrief = createSelector(
  getCampaignBriefState,
  (state: CampaignBriefState) => state.data
);

export const getBriefId = createSelector(getBrief, (brief: ICampaignBriefData) => brief.id);

export const getResourceType = createSelector(
  getBrief,
  (brief: ICampaignBriefData) => brief.resourcetype
);

export const getName = createSelector(getBrief, (brief: ICampaignBriefData) => brief.name);

export const getStatus = createSelector(getBrief, (brief: ICampaignBriefData) => brief.status);

export const getOwner = createSelector(
  getCampaignBriefState,
  (state: CampaignBriefState) => state.data.briefOwner
);

export const getOwnerId = createSelector(getOwner, (owner: IBriefOwner) => owner.id);

export const getDependentUserDetails = createSelector(
  getBrief,
  (brief: ICampaignBriefData) => brief.dependentUserDetails
);

export const getErrors = createSelector(
  getCampaignBriefState,
  (state: CampaignBriefState) => state.errors
);

export const getFormErrors = createSelector(
  getCampaignBriefState,
  (state: CampaignBriefState) => state.formErrors
);

export const isLoading = createSelector(
  getCampaignBriefState,
  (state: CampaignBriefState) => state.loading
);

export const isNewBriefModelOpen = createSelector(
  getCampaignBriefState,
  (state: CampaignBriefState) => state.showNewBriefModal
);

export const getAttachedFiles = createSelector(
  getCampaignBriefState,
  (state: CampaignBriefState) => state.attachedFiles
);

export const isProductModalOpen = createSelector(
  getCampaignBriefState,
  (state: CampaignBriefState) => state.showAddProductModal
);

export function save(form: CampaignBriefForm) {
  Store.dispatch(actions.save(form));
}

export function rename(form: CampaignBriefForm) {
  Store.dispatch(actions.rename(form));
}

export function resetState() {
  Store.dispatch(actions.resetState());
}

export function fetchBrief(id: number | string) {
  Store.dispatch(actions.fetch(Number(id)));
}

export function search(term: string) {
  Store.dispatch(actions.search(term));
}

export function clearSearchResults() {
  Store.dispatch(actions.clearSearchResults());
}

export const resetCampaignAttributeText = (attributeName: string) => {
  Store.dispatch(actions.resetCampaignAttributeText(attributeName));
};

export function closeNewBriefModal() {
  Store.dispatch(actions.closeNewBriefModal());
}

export function openNewBriefModal() {
  Store.dispatch(actions.openNewBriefModal());
}
export function closeAddProductsModal() {
  Store.dispatch(actions.toggleShowAddProductsModal(false));
}
export function openAddProductsModal() {
  Store.dispatch(actions.toggleShowAddProductsModal(true));
}
export function create(form: CreateCampaignBriefForm) {
  Store.dispatch(actions.create(form));
}

export function removeAttachedFile(id: number) {
  Store.dispatch(actions.removeAttachedFile(id));
}

export function uploadAttachmentFile(briefId: string, file: File) {
  Store.dispatch(actions.uploadAttachedFile(briefId, file));
}

export function duplicate(form: DuplicateCampaignBriefForm) {
  Store.dispatch(actions.duplicate(form));
}
